export const FETCH_WHATSAPP_ACCOUNTS_REQUEST = 'FETCH_WHATSAPP_ACCOUNTS_REQUEST';
export const FETCH_WHATSAPP_ACCOUNTS_SUCCESS = 'FETCH_WHATSAPP_ACCOUNTS_SUCCESS';

export const FETCH_DMS_PROVIDERS_REQUEST = 'FETCH_DMS_PROVIDERS_REQUEST';
export const FETCH_DMS_PROVIDERS_SUCCESS = 'FETCH_DMS_PROVIDERS_SUCCESS';
export const FETCH_DMS_PROVIDERS_FAILURE = 'FETCH_DMS_PROVIDERS_FAILURE';
